/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Invitation_AcceptedInputs */

const fr_api_invitation_accepted = /** @type {(inputs: Api_Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette invitation a déjà été acceptée. Connectez-vous pour continuer.`)
};

const en_api_invitation_accepted = /** @type {(inputs: Api_Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invitation has already been accepted. Sign in to continue.`)
};

/**
* | output |
* | --- |
* | "This invitation has already been accepted. Sign in to continue." |
*
* @param {Api_Invitation_AcceptedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_invitation_accepted = /** @type {((inputs?: Api_Invitation_AcceptedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Invitation_AcceptedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_invitation_accepted(inputs)
	return fr_api_invitation_accepted(inputs)
});